import { configLastStepKind, PMSSteps } from './constants'
import PendingEmailConfirmation from './EmailConfirmation'
import EnvironmentSetup from './EnvironmentSetup'
import FAQCard from './FAQ'
import styles from './MultiStepPMSLogin.module.scss'
import ohip from './ohip.png'
import oracle from './oracle.png'
import PartnerRegistration from './PartnerRegistration'
import PMSLoginSuccess from './PMSLoginSuccess'
import RegisterApiUser from './RegisterApiUser'
import ReviewAndFinalize from './ReviewAndFinalize'

const OHIPPMSLogin = ({ ohipConfigData, setIsOHIPConfigFinazized, setUpdateConfig }) => {
  const { lastStep, tenantId, propertyId, hubId } = ohipConfigData

  return (
    <div className={styles.wrapper}>
      {configLastStepKind[lastStep] !== 'Step6Completed' ? (
        <div className={styles.card}>
          <div className={styles.stepsGuide}>
            <div className={styles.logo}>
              <img className={styles.logoLeft} src={oracle} alt={'oracle'} />
              <img className={styles.logoRight} src={ohip} alt={'ohip'} />
            </div>
            <div className={styles.stepTitleContainer}>
              {PMSSteps.map(step => (
                <p
                  key={step.title}
                  className={
                    step.status === lastStep ? styles.selectedStep : styles.stepTitle
                  }
                >
                  {step.order}. {step.title}
                </p>
              ))}
            </div>
          </div>
          <div className={styles.stepsContainer}>
            {configLastStepKind[lastStep] === 'Step1PartnerRegistration' && (
              <PartnerRegistration setUpdateConfig={setUpdateConfig} />
            )}
            {configLastStepKind[lastStep] === 'Step2ApiUserRegistration' && (
              <RegisterApiUser setUpdateConfig={setUpdateConfig} tenantId={tenantId} />
            )}
            {configLastStepKind[lastStep] === 'Step3EmailConfirmationPending' && (
              <PendingEmailConfirmation
                setUpdateConfig={setUpdateConfig}
                tenantId={tenantId}
              />
            )}
            {configLastStepKind[lastStep] === 'Step4EnvironmentSetup' && (
              <EnvironmentSetup setUpdateConfig={setUpdateConfig} tenantId={tenantId} />
            )}
            {configLastStepKind[lastStep] === 'Step5ReviewAndFinalize' && (
              <ReviewAndFinalize
                hubId={hubId}
                tenantId={tenantId}
                propertyId={propertyId}
                setIsOHIPConfigFinazized={setIsOHIPConfigFinazized}
                setUpdateConfig={setUpdateConfig}
              />
            )}
          </div>
        </div>
      ) : (
        <PMSLoginSuccess hubId={hubId} propertyId={propertyId} />
      )}
      {(configLastStepKind[lastStep] === 'Step1PartnerRegistration' ||
        configLastStepKind[lastStep] === 'Step2ApiUserRegistration') && (
        <FAQCard selectedStep={lastStep} />
      )}
    </div>
  )
}

export default OHIPPMSLogin
